module.exports = __webpack_public_path__ + "static/img/egg_b_11.00f12c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_11.png
// module id = VtKx
// module chunks = 1